/* eslint-disable */
export const numberRegex = /(?<=\/)(\d+)(?=\/|\?|$)/g;
export const emailRegex =
  /(?<=\/)(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]+@[A-Z0-9][A-Z0-9\-]*(\.[A-Z]{2,})+)(?=\/|\?|$)/gi;
export const uuidv4Regex =
  /(?<=\/)([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})(?=\/|\?|$)/gi;

export const redactApiKeyRegex = /(?<=\/api_keys\/)[^\/]*/;
export const redactBillingInvoiceRegex = /(?<=\/billing\/invoice\/)[^\/]*/;
export const redactVerifySenderRegex = /(?<=\/verified_senders\/verify\/)[^\/]*/;
export const redactTeammateRegex = /(?<=\/teammates\/)[^\/]*/;
export const redactSubusersRegex = /(?<=\/subusers\/)[^\/]*/;
export const redactOfferingsRegex = /(?<=\/offerings\/)[^\/]*/;

export const redactDynamicTemplateRegex = /(?<=\/dynamic_templates\/ui\/)[^\/]*/;
// @ts-ignore
export const redactPaymentRegex = /(?<=\/dashboard\/payment\/)([^\/]*)\/([^\/]*)/;
